<template>
  <div>
    <el-select
      :value="getValueSting"
      @change="handleChange"
      autocomplete='reset'
      style="width: 100%;"
      v-if="type=='select'"
      :disabled="disabled"
      :clearable="clearable"
      :multiple="multiple"
      :collapse-tags="collapseTags"
      filterable
      :popper-append-to-body="false"
      :placeholder="placeholder || $t('system.select.common_select')">
      <el-option
        v-for="(dict,index) in dictOptions"
        :key="code + index"
        :disabled="disabledOptions(dict)"
        :label="$languageChoose({
                        zh: dict.text,
                        en: dict.textEn,
                    })"
        :title="$languageChoose({
                        zh: dict.text,
                        en: dict.textEn,
                    })"
        :value="dict.value"
      >
      </el-option>
    </el-select>
    <div v-if="type=='radio'">
      <el-radio-group v-model="value" :disabled="disabled" @change="handleChange">
        <el-radio
          v-for="(dict,index) in dictOptions"
          :key="index"
          :label="dict.value">{{
            $languageChoose({
              zh: dict.text,
              en: dict.textEn
            })
          }}
        </el-radio>
      </el-radio-group>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';

const whiteCodeList = ['city', 'province', 'airba_category']; // 需要单独请求和处理
// import { getDictItemsByCode } from '@/api/dict/dict';

export default {
  name: 'DictSelect',
  props: {
    code: { // 字典表对应的key
      type: String,
      require: true
    },
    type: { // 选择类型, radio/checkbox/select, 默认为 select
      type: String,
      default: 'select'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    disabled: Boolean, // 是否禁用
    value: [String, Number],
    all: { // 是否需要添加 All 选项
      type: Boolean,
      default: false
    },
    allKey: { // 选择 all 时 set 的key, 默认为 undefined
      default: undefined
    },
    clearable: {
      type: Boolean,
      default: true
    },
    changeCallback: {
      type: Function
    },
    disabledOptions: {
      type: Function,
      default: () => {
        return false;
      }
    }
  },
  model: {
    prop: 'value',
    event: 'changeCodeValue'
  },
  data() {
    return {
      localValue: undefined
    };
  },
  watch: {
    code: {
      immediate: true,
      handler() {
        this.initDictData();
      }
    }
  },
  computed: {
    ...mapGetters(['dictMap']),
    getValueSting() {
      return (this.value && this.dictMap[this.code]) ? this.multiple ? this.value : this.value.toString() : undefined;
    },
    dictOptions() {
      let options = [];
      if (this.all) {
        // 添加all 选项
        options.push({
          text: '全部',
          textEn: 'All',
          value: this.allKey
        });
      }
      if (this.dictMap[this.code]) {
        options = options.concat(this.dictMap[this.code].options);
      }
      return options;
    }
  },
  methods: {
    ...mapActions(['getDictProvinceList', 'getDictAribaCategoryList']),
    // 获取字典数据
    initDictData() {
      if (whiteCodeList.indexOf(this.code) != -1) {
        switch (this.code) {
          case 'province':
            this.getDictProvinceList();
            break;
          case 'airba_category':
            this.getDictAribaCategoryList();
            break;
        }
      } else {
        // 根据字典Code, 初始化字典数组
        this.$getDictionary(this.code).then(res => {
        });
      }
    },
    handleChange(val) {
      this.$emit('changeCodeValue', val);
      // 触发change 事件
      if (this.code === 'airba_category') {
        this.$emit('change', val, this.dictOptions, this.code);
      } else {
        this.$emit('change', val, this.code);
      }
    }
  },
  mounted() {
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// DictSelect.vue?52d6983c